import * as React from "react";
import {css, cx} from "emotion";

import "./tooltip-2.scss";

import {cs}          from "@Common/react/chain-services";
import {GlobalEvent} from "@Common/react/global-event";
import {Static2}     from "@Common/react/static-2";
import {UseState}    from "@Common/react/use-state";

import {Responsive2} from "../../../../responsive-2";

const distance=3;

/**
 *
 * @param color
 * @param getMessage
 * @param direction east | west | east-south | south-east .
 *                  About east-south vs south-east, they are different, that's intentional
 * @param next
 * @constructor
 */
export const Tooltip2 = ({color=undefined, getMessage=null, direction="south-east", next}) => cs(
    ["state", (_, next) => UseState({
        // initValue: "ready",
        next,
    })],
    ["dom", (_, next) => Static2({next})],
    ["responsive", (_, next) => Responsive2({
        translate: (v) => v < 768 ? "sm" : "md",
        next,
    })],
    ["size", (_, next) => next({width: 310, height: 44})],
    ["direction", ({responsive}, next) => next(responsive === "sm" ? "center" : direction )],
    ({state, dom, size, direction, responsive}) => <>
        {next({
            ref: dom.set,
            render: () => (
                state.value && (
                    <div {...{
                        className: cx("tooltip-2-6fy", css`
                            --width: ${size.width}px;
                            --distance: ${distance}px;
                        `),
                        style: {
                            top: state.value.rect.y,
                            left: state.value.rect.x,
                            width: state.value.rect.width,
                            height: state.value.rect.height,
                        },
                    }}>
                        {GlobalEvent({
                            eventName: "scroll",
                            fn: () => state.onChange(null),
                        })}
                        {direction === "center" && <div className={"center-pointer"}></div>}
                        <div className={cx("box", direction)}>
                            <div className="text" xd-qa-type="label" xd-qa-name="Message">
                                {getMessage()}
                            </div>
                            {responsive === "sm" && (
                                <button
                                    className="close"
                                    onClick={() => state.onChange(null)}
                                >
                                    &times;
                                </button>
                            )}
                        </div>
                    </div>
                )
            ),
            onClick: () => !state.value && state.onChange({name: "ready", rect: dom.get().getBoundingClientRect()}),
            onMouseEnter: () => state.onChange({name: "ready", rect: dom.get().getBoundingClientRect()}),
            onMouseLeave: () => state.onChange(null),
        })}


    </>,
);

// const Position = ({distance, disabled, next}) => cs(
//     ["domRef", (_, next) => UseState({next})],
//     ["collected", (_, next) => UseState({next})],
//     ({domRef, collected}) => fragments(
//         next({
//             ref: (ref) => {
//                 if (!domRef.value && ref) {
//                     domRef.onChange(ref);
//                 }
//             },
//             value: collected.value && {
//                 name: calPosition(collected.value),
//                 anchor: collected.value.target,
//             },
//         }),
//         domRef.value && !disabled && (
//             Interval({
//                 startImmediately: true,
//                 delay: 2000,
//                 fn: () => {
//                     collected.onChange({
//                         target: keepOnly(domRef.value.getBoundingClientRect(), ["x", "y", "width", "height"]),
//                         window: {
//                             width: window.innerWidth,
//                             height: window.innerHeight,
//                         }
//                     });
//                 },
//             })
//         ),
//     ),
// );
//
// const calPosition = ({target, window}) => {
//     console.log({target, window});
// };